/**
 * Shared card frame for the coaching vertical slice. Ensures a
 * consistent heading structure and section-level error / empty states.
 */
import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export const CoachingMetric = ({ label, value, testId, className }) => (
  <div className={cn("app-card-elevated p-3 sm:p-4 min-w-0", className)}>
    <div className="card-label">{label}</div>
    <div className="text-sm text-dark-text-primary mt-1 break-words" data-testid={testId}>
      {value ?? "—"}
    </div>
  </div>
);

export const CoachingSectionCard = ({
  title,
  subtitle,
  headingId,
  testId,
  children,
  error,
  empty,
  actions,
  elevated = false,
  className,
}) => (
  <section
    aria-labelledby={headingId}
    data-testid={testId}
    className={cn(
      elevated ? "app-card-elevated" : "app-card",
      "p-5 sm:p-6",
      className
    )}
  >
    <div className="flex items-baseline justify-between gap-3 flex-wrap">
      <div className="min-w-0">
        <h2 id={headingId} className="section-title">
          {title}
        </h2>
        {subtitle && (
          <p className="meta-text mt-1">{subtitle}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap gap-2 shrink-0">{actions}</div>
      )}
    </div>
    <div className="mt-4">
      {error ? (
        <div
          role="alert"
          data-testid={`${testId}-error`}
          className="flex items-start gap-2 text-analytics-amber text-sm app-card-elevated p-3"
        >
          <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
          <span>{error.message || "Section unavailable."}</span>
        </div>
      ) : empty ? (
        <p className="text-dark-text-secondary text-sm" data-testid={`${testId}-empty`}>
          {empty}
        </p>
      ) : (
        children
      )}
    </div>
  </section>
);
